<div class="modal modal-v2 fade show viewport-{{viewPort.toString()}} {{ customClassName }}" role="dialog" [ngClass]="{'visible' : visible, 'is-scrollable': scrollable, 'tabulated': tabulated}">
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <div class="modal-content">
      @if (!hideCloseBtn) {
        <a (click)="hide()" class="modal-v2-close"><i class="far fa-times"></i></a>
      }

      <ng-content></ng-content>
    </div>
  </div>
</div>
